import { Component, Input } from '@angular/core';
import { EnergyType } from '@essent/new-customer';
import { Offer } from '@innogy/become-a-customer/shared/interfaces';
import type { InnogyComponentRendering } from '@core/jss-models';
import { CommonModule } from '@angular/common';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';

import { OfferBreakdownRowComponent } from '../offer-breakdown-row/offer-breakdown-row.component';
import { SelectCommodityPipe } from '../../pipe';

@Component({
  selector: 'wl-offer-breakdown',
  templateUrl: './offer-breakdown.component.html',
  standalone: true,
  imports: [
    CommonModule,
    SelectCommodityPipe,
    OfferBreakdownRowComponent,
    CSCaptureDirective,
  ],
})
export class OfferBreakdownComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public offer?: Offer;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public rendering: InnogyComponentRendering | undefined;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public hideIncentiveWhenUavailable = false;

  public energyType = EnergyType;
}
